/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Purchasefailed2Inputs */

const zh_creditpack_purchasefailed2 = /** @type {(inputs: Creditpack_Purchasefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法启动结账`)
};

const en_creditpack_purchasefailed2 = /** @type {(inputs: Creditpack_Purchasefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start checkout`)
};

const es_creditpack_purchasefailed2 = /** @type {(inputs: Creditpack_Purchasefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar el pago`)
};

/**
* | output |
* | --- |
* | "Failed to start checkout" |
*
* @param {Creditpack_Purchasefailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_purchasefailed2 = /** @type {((inputs?: Creditpack_Purchasefailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Purchasefailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_purchasefailed2(inputs)
	if (locale === "en") return en_creditpack_purchasefailed2(inputs)
	return es_creditpack_purchasefailed2(inputs)
});
export { creditpack_purchasefailed2 as "creditPack_purchaseFailed" }